import { inlineMediaQueryMixin } from './inlineMediaQueryMixin';
import { spaceMixin } from './spaceMixin';
var marginValue = function marginValue(value) {
  return function (props) {
    if (value === 'auto') {
      return value;
    }
    return spaceMixin(value)(props);
  };
};

/** @mixin marginMixin */
/**
 * Adds margin props.
 *
 * <ul>
 *     <li><code>margin</code></li>
 *     <li><code>marginX</code></li>
 *     <li><code>marginY</code></li>
 *     <li><code>marginTop</code></li>
 *     <li><code>marginBottom</code></li>
 *     <li><code>marginLeft</code></li>
 *     <li><code>marginRight</code></li>
 * </ul>
 *
 * @example
 * import { marginMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${marginMixin}
 * `;
 *
 * <Component margin="xl" marginTop="lg" marginX="auto" />
 * <Component margin={{ default: 'sm', md: 'lg' }} />
 *
 * @method
 * @param {object} props
 * @param {object} props.theme - The styled-components theme object.
 * @return {CSSObject}
 */
export var marginMixin = function marginMixin(props) {
  var styles = [];
  if ('margin' in props) {
    styles.push(inlineMediaQueryMixin('margin', function (mediaProps) {
      return "margin: " + marginValue(mediaProps.margin)(mediaProps) + ";";
    })(props));
  }
  if ('marginX' in props) {
    styles.push(inlineMediaQueryMixin('marginX', function (mediaProps) {
      return "\n                    margin-left: " + marginValue(mediaProps.marginX)(mediaProps) + ";\n                    margin-right: " + marginValue(mediaProps.marginX)(mediaProps) + ";\n                ";
    })(props));
  }
  if ('marginY' in props) {
    styles.push(inlineMediaQueryMixin('marginY', function (mediaProps) {
      return "\n                    margin-top: " + marginValue(mediaProps.marginY)(mediaProps) + ";\n                    margin-bottom: " + marginValue(mediaProps.marginY)(mediaProps) + ";\n                ";
    })(props));
  }
  if ('marginTop' in props) {
    styles.push(inlineMediaQueryMixin('marginTop', function (mediaProps) {
      return "margin-top: " + marginValue(mediaProps.marginTop)(mediaProps) + ";";
    })(props));
  }
  if ('marginBottom' in props) {
    styles.push(inlineMediaQueryMixin('marginBottom', function (mediaProps) {
      return "margin-bottom: " + marginValue(mediaProps.marginBottom)(mediaProps) + ";";
    })(props));
  }
  if ('marginLeft' in props) {
    styles.push(inlineMediaQueryMixin('marginLeft', function (mediaProps) {
      return "margin-left: " + marginValue(mediaProps.marginLeft)(mediaProps) + ";";
    })(props));
  }
  if ('marginRight' in props) {
    styles.push(inlineMediaQueryMixin('marginRight', function (mediaProps) {
      return "margin-right: " + marginValue(mediaProps.marginRight)(mediaProps) + ";";
    })(props));
  }
  return styles;
};